import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportIssueModalComponent } from './components/report-issue-modal/report-issue-modal.component';
import { MeetLoggerModule } from '../meet-logger/meet-logger.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReportIssueFormModule } from '@mitel-internal/cloudlink-components-catalogue';



@NgModule({
  declarations: [
    ReportIssueModalComponent
  ],
  imports: [
    CommonModule,
    MeetLoggerModule,
    TranslateModule,
    ReportIssueFormModule
  ],
  exports: [
  ]
})
export class ReportProblemModule { }
